import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import SellerDashboard from '../components/bookshop/dashboard.vue';
import LibrarianDashboard from '../components/library/dashboard.vue';
import { ViewerContext } from '../types/viewer_context';

@Component({
  components: { LibrarianDashboard, SellerDashboard },
})
export default class Home extends Vue {
  @Getter public viewerContext?: ViewerContext;
}
